// src/dummyData/dummyTransactions.tsx
import { MxTransaction } from '../../models/mx';

export const dummyTransactions: MxTransaction[] = [
  {
    account_guid: 'dummy-001',
    amount: 45.67,
    category: 'Food & Dining',
    date: '2023-12-01',
    description: 'Dinner at local restaurant',
    guid: 'dummy-tx-001',
    status: 'POSTED',
    top_level_category: 'Food & Dining',
    type: 'DEBIT',
  },
  {
    account_guid: 'dummy-002',
    amount: 1200,
    category: 'Income',
    date: '2023-11-30',
    description: 'Monthly Salary',
    guid: 'dummy-tx-002',
    status: 'POSTED',
    top_level_category: 'Income',
    type: 'CREDIT',
  },
  {
    account_guid: 'dummy-003',
    amount: 75.50,
    category: 'Entertainment',
    date: '2023-12-02',
    description: 'Movie tickets',
    guid: 'dummy-tx-003',
    status: 'PENDING',
    top_level_category: 'Entertainment',
    type: 'DEBIT',
  },
  {
    account_guid: 'dummy-004',
    amount: 30,
    category: 'Auto & Transport',
    date: '2023-12-03',
    description: 'Gas station fill-up',
    guid: 'dummy-tx-004',
    status: 'POSTED',
    top_level_category: 'Auto & Transport',
    type: 'DEBIT',
  },
  {
    account_guid: 'dummy-005',
    amount: 99.99,
    category: 'Shopping',
    date: '2023-12-04',
    description: 'New headphones',
    guid: 'dummy-tx-005',
    status: 'MANUAL',
    top_level_category: 'Shopping',
    type: 'DEBIT',
  },
];